import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AutomationVersionDependencyInventory } from '@/types/automations.ts';
import { get_automation_version_dependencies_url } from '@/utils/urls.ts';

const useRetrieveAutomationVersionDependencies = (versionId?: string) => {
  const apiClient = useApiClient();

  return useQuery<AutomationVersionDependencyInventory, Error>({
    queryKey: ['automation-version-dependencies', versionId],
    queryFn: async () => {
      const response = await apiClient.get(get_automation_version_dependencies_url(versionId));
      return response.data;
    },
    enabled: !!versionId,
  });
};

export default useRetrieveAutomationVersionDependencies;
